import HotArea from './components/HotArea'

export { removeid, addid } from './utils'
export default HotArea



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/meta/HotArea/index.js